<script>
import { defineComponent, computed, getCurrentInstance } from 'vue'
import Checkbox from '@/components/Input/Checkbox.vue'
import FormItem from '@/components/Input/FormItem.vue'
import BundleItemInput from './BundleItemInput.vue'
import { ValidationProvider } from 'vee-validate'
import BundleTypeInput from './BundleTypeInput.vue'

/**
 * @typedef {import('@/types/product').ProductFormModel} ProductFormModel
 */

/**
 * Define component
 */
export default defineComponent({
  components: {
    Checkbox,
    FormItem,
    BundleItemInput,
    ValidationProvider,
    BundleTypeInput,
},
  props: {
    value: {
      // /** @type {import('@/types/product').ProductBundle} */
      type: [Object],
      default: () => null,
    },
    product: {
      // /** @type {import('vue').PropType<ProductFormModel} */
      type: Object,
      required: true,
    },
    business: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: false,
    },
  },
  setup(props, { emit }) {
    const { $confirm } = getCurrentInstance().proxy.$root

    const isProductBundling = computed(() => !!props.value?.bundles.length || props.value?.type)
    const toggleIsProductBundling = () => {
      if (isProductBundling.value &&  props.value.bundles.length) {
        return $confirm({
          title: getCurrentInstance().proxy.$t('product.delete_bundling_confirm_title'),
          content: getCurrentInstance().proxy.$t('product.delete_bundling_confirm_content'),
          onOk: () => {
            emit('input', null)
          },
        })
      }

      emit('input', {
        type: isProductBundling.value ? null : (props.value.type || 'SOFT'),
        bundles: isProductBundling.value ? [] : props.value.bundles,
      })
    }

    const onBundleItemInput = (values) => {
      emit('input', {
        ...props.value,
        bundles: values,
      })
    }

    return {
      isProductBundling,
      toggleIsProductBundling,
      onBundleItemInput,
    }
  },
})
</script>

<template>
  <div>
    <div v-if="$route.query.edit">
      <a-col class="mb-2" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.product_bundling') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="18">
        <div class="mb-2">
          : {{ isProductBundling || $t('product.no_bundling') }}
        </div>
      </a-col>
    </div>
    <FormItem v-else>
      <Checkbox
        :value="isProductBundling"
        :label="$t('product.product_bundling')"
        :disabled="$route.query.edit || $route.query.master_product ? true : false"
        @input="toggleIsProductBundling"
      />
    </FormItem>

    <div v-if="isProductBundling">
      <div class="mb-1">
        <FormItem>
          <BundleTypeInput v-model="value.type" />
        </FormItem>
      </div>

      <ValidationProvider
        v-slot="{ errors }"
        tag="div"
        rules="required"
        name="Bundling item"
        style="max-width: 700px"
      >
        <div v-if="errors.length" class="ant-form-explain text-danger mb-2">
          {{ errors[0] }}
        </div>
        <BundleItemInput
          :value="value.bundles"
          :business="business"
          :product="product"
          @input="onBundleItemInput"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
